import { render, staticRenderFns } from "./gdpr-information-request.vue?vue&type=template&id=9cb66d3a"
import script from "./gdpr-information-request.vue?vue&type=script&lang=ts"
export * from "./gdpr-information-request.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports